module.exports = __webpack_public_path__ + "img/logo-freshsolution@3x.b96bf1b5.png";